import { Actions } from '../../interfaces'
import { Country } from '@/entities/public'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { Country },
  actions: { [Country.name]: actions },
}
